import {Dispatch} from 'redux';
import {IResponse} from './Request';
import ErrorManager from './ErrorManager';

export default (dispatch: Dispatch, response: IResponse) => {
  ErrorManager(dispatch, response)
}
